import React, { useState } from 'react';
// import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { Menu, MenuItem, MenuProps, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import Logo from '../../../shared/components/Logo';
import { logoutUser, User } from '../../../shared/services/user';

const useStyles = makeStyles({
  nav: {
    background: 'white',
    color: 'black',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    padding: '10px 30px',
    boxShadow: '0 1px 0 0 rgba(154, 154, 154, 0.5)',
  },
  userMenuButton: {
    width: '150px',
    textTransform: 'none',
    display: 'flex',
    justifyContent: 'space-between',
  },
  userMenu: {
    marginTop: '40px',
    ul: {
      padding: '0',
    },
  },
  userMenuItem: {
    width: '150px',
    display: 'flex',
    justifyContent: 'space-between',
  },
});

interface HeaderProps {
  user: User;
}

const Header: React.FC<HeaderProps> = ({ user }: HeaderProps) => {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState<MenuProps['anchorEl']>(null);

  const { firstName, lastName } = user;

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <nav className={classes.nav} style={{ height: '80px' }}>
      <Logo height={50} />
      <div>
        <Button
          className={classes.userMenuButton}
          aria-controls="user-menu"
          aria-haspopup="true"
          onClick={(event) => setAnchorEl(event.currentTarget)}
        >
          {`${firstName} ${lastName}`}
          <FontAwesomeIcon icon={faChevronDown} size="1x" />
        </Button>
        <Menu
          className={classes.userMenu}
          id="user-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {/* TODO: change password */}
          {/* <MenuItem className={classes.userMenuItem} component={NavLink} to="/changePassword" onClick={handleClose}>
            Change password
          </MenuItem> */}
          <MenuItem className={classes.userMenuItem} onClick={() => logoutUser()}>
            Logout
          </MenuItem>
        </Menu>
      </div>
    </nav>
  );
};

export default Header;
